import React, { createContext, useEffect, useMemo, useState } from "react";
import axios from "axios";

export const GlobalContext = createContext();

export const GlobalProvider = (props) => {
  const [userDetails, setUserDetails] = useState({
    isAuthenticated: false,
    name: "",
    userId: "",
    schoolId: "",
    role: "",
    profileImageUrl: undefined,
    selectedTab: "Dashboard",
    selectedPath: {
      subject: "",
      chapter: "",
      topic: "",
    },
  });
  const [loading, setLoading] = useState(false);

  const schoolLevelAccess = useMemo(() => {
    const ids = [userDetails?.schoolId, userDetails?.school?._id];
    const allowedIds = ["611ce503ded7800500d3b287","6505d6ae7b22ddb697a4b2db"];
    return ids.find((id) => allowedIds.includes(id));
  }, [userDetails]);

  const boardLevelAccess = useMemo(() => {
    return userDetails?.school?.board === "DAV";
  });

  const [allSubjects, setAllSubjects] = useState([]);
  const [subLoading, setSubLoading] = useState(false);

  const gradeSection = useMemo(() => {
    return `${userDetails?.grade || ""}-${userDetails?.section}`;
  }, [userDetails]);

  const getAllSubjects = async () => {
    setSubLoading(true);
    await fetch(
      `${process.env.REACT_APP_ORIGIN}/api/v1/grades/${userDetails.grade}/sections/${userDetails.section}/subjects`,
      {
        headers: {
          token: `${window.localStorage.getItem("authToken")}`,
        },
      },
    )
      .then((response) => response.json())
      .then((response) => {
        let subjects = response.data.subjects
          .filter(
            (item) =>
              item?.subjectData?.lang ===
              (window.localStorage.getItem("language") || "english"),
          )
          .sort((a, b) => a.priority - b.priority);

        if (subjects.length) {
          window.localStorage.setItem("sectionId", subjects[0].sectionId);
        }

        setAllSubjects(subjects || []);
        setSubLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  const CheckAuth = async () => {
    const authToken = localStorage.getItem("authToken");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ORIGIN}/api/v1/auth/validate/${authToken}`,
      );
      if (response.data.status === "authorized") {
        const {
          name,
          userId,
          school,
          role,
          grade,
          section,
          sectionId,
          profile,
        } = response.data.data.user;
        localStorage.setItem("userGrade", `${grade}-${section}`);
        localStorage.setItem("sectionId", sectionId);
        setUserDetails({
          isAuthenticated: true,
          name,
          userId,
          school,
          role,
          grade,
          section,
          profileImageUrl: profile?.fileUrl,
          authToken,
          selectedTab: userDetails.selectedTab,
          selectedPath: userDetails.selectedPath,
        });
      }

      setLoading(true);
    } catch (error) {
      setUserDetails({ isAuthenticated: false });
      setLoading(true);
    }
  };

  useEffect(() => {
    CheckAuth();
  }, []);

  useEffect(() => {
    if (!userDetails.isAuthenticated || subLoading || allSubjects.length)
      return;
    getAllSubjects();
  }, [userDetails]);

  return (
    <>
      {loading && (
        <GlobalContext.Provider
          value={{
            userDetails,
            setUserDetails,
            schoolLevelAccess,
            boardLevelAccess,
            allSubjects,
            subLoading,
            gradeSection
          }}
        >
          {props.children}
        </GlobalContext.Provider>
      )}
    </>
  );
};
